/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="zfr-action-exit">\n  <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/x-icon_thin.png">\n</div>\n\n';
 if (data.state === 'initial') { ;
__p += '\n  <div class="zfr-recording-tips">\n    <div class="zfr-tips-title">\n      Tips for a High Quality Recording\n    </div>\n    <div class="zfr-tip">\n      <span class="zfr-tip-number">1.</span>\n      <span class="zfr-tip-text">\n        Make sure you\'re in a quiet place—avoid chatter, traffic, office fans, or other noise.\n      </span>\n    </div>\n    <div class="zfr-tip">\n      <span class="zfr-tip-number">2.</span>\n      <span class="zfr-tip-text">\n        Find a well lit space with the light coming from BEHIND the camera and pointing AT your face.\n      </span>\n    </div>\n    <div class="zfr-tip">\n      <span class="zfr-tip-number">3.</span>\n      <span class="zfr-tip-text">\n        Relax—don\'t worry about getting it perfect! You can preview your video before it uploads.\n      </span>\n    </div>\n    <div class="zfr-tip">\n      <span class="zfr-tip-number">4.</span>\n      <span class="zfr-tip-text">\n        Keep it brief!\n      </span>\n    </div>\n    <div class="zfr-setup-recorder zfr-action-request-camera">\n      Click here to set up recorder\n    </div>\n  </div>\n';
 } ;
__p += '\n\n';
 if (data.state === 'countdown') { ;
__p += '\n  <div class="zfr-countdown">\n    <span class="zfr-countdown-number"></span>\n  </div>\n';
 } ;
__p += '\n\n';
 if (data.state === 'recording') { ;
__p += '\n  <div class="zfr-is-recording-indicator"></div>\n';
 } ;
__p += '\n\n';
 if (data.state === 'bad_browser') { ;
__p += '\n  <div class="zfr-error-state">\n    <div class="zfr-error-message">\n      This browser does not support recording via webcam.\n      <br/>\n      Please use Google Chrome or Mozilla Firefox.\n    </div>\n  </div>\n';
 } ;
__p += '\n\n';
 if (data.error) { ;
__p += '\n  <div class="zfr-error-state">\n    <div class="zfr-error-message">\n      ';
 if (data.error === 'ConstraintNotSatisfiedError') { ;
__p += '\n        There was an error loading the camera or microphone.\n      ';
 } else if (data.error === 'PermissionDeniedError') { ;
__p += '\n        To record, you need to allow this site to access your camera and microphone.\n      ';
 } else if (data.error === 'PermissionDismissedError') { ;
__p += '\n        To record, you need to allow this site to access your camera and microphone.\n      ';
 } else if (data.error === 'FailedToLoadCamera') { ;
__p += '\n        There was an error loading the camera.\n      ';
 } else if (data.error === 'FailedToLoadMicrophone') { ;
__p += '\n        There was an error loading the microphone.\n      ';
 } else { ;
__p += '\n        There was an unknown error that occured in the recorder.\n      ';
 } ;
__p += '\n    </div>\n    <div class="zfr-reload-after-error-button zfr-action-record-again">\n      Reload Recorder\n    </div>\n  </div>\n';
 } ;
__p += '\n\n';
 if (data.state === 'recording-complete') { ;
__p += '\n  <div class="zfr-recording-complete-options">\n    <div class="zfr-save-recording zfr-action-accept-video">\n      <i class="fa fa-check" aria-hidden="true"></i>\n      Save &amp; Upload\n    </div>\n    <div class="zfr-preview-recording zfr-action-start-playback">\n      <i class="fa fa-eye" aria-hidden="true"></i>\n      Preview\n    </div>\n    <div class="zfr-record-again zfr-action-record-again">\n      <i class="fa fa-trash" aria-hidden="true"></i>\n      Delete &amp; Record Again\n    </div>\n  </div>\n';
 } ;
__p += '\n\n<div class="zfr-ui-bottom-bar">\n  \n  ';
 if (data.includes(['waiting-to-record', 'countdown', 'recording'], data.state)) { ;
__p += '\n    <div class="zfr-recording-timer">\n      Time:\n      <span class="zfr-current-recording-second">0</span> / ' +
__e(data.maxDuration) +
' seconds\n    </div>\n    \n    <div class="zfr-flattery">\n      You look great today!\n    </div>\n  ';
 } ;
__p += '\n  \n\n  ';
 if (data.state === 'waiting-to-record') { ;
__p += '\n    <div class="zfr-record-button zfr-main-button zfr-action-start-countdown">\n      <i class="fa fa-circle" aria-hidden="true"></i>\n      Start Recording\n    </div>\n  ';
 } ;
__p += '\n\n  ';
 if (data.state === 'recording') { ;
__p += '\n    <div class="zfr-stop-recording zfr-main-button zfr-action-stop-recording">\n      Stop recording\n    </div>\n  ';
 } ;
__p += '\n\n  ';
 if (data.state === 'playback') { ;
__p += '\n    <div class="zfr-skip-playback zfr-main-button zfr-action-skip-playback">\n      Skip playback\n    </div>\n  ';
 } ;
__p += '\n  \n\n  \n</div>\n\n';
return __p
}
